<template>
	<div class="Navigation">

		<!-- Situation Gallery -->
		<md-button class="md-icon-button na-gallery" @click="toggleGallery">
			<span class="situationName">{{$t(currentSituation ? currentSituation.getName() : "Undefined")}}</span>	
			<ChevronDown v-if="!situationGalleryVisible"/>
			<ChevronUp v-else/>
		</md-button>

		<!-- Shop Button -->
		<div class="na-shop-container">
			<md-button class="md-icon-button na-shop" @click="openShop()">
				<div class="na-shop-wrapper">
					<img src="@/assets/Shop.svg" alt=""/>
					<p>{{$t("Shop").toUpperCase()}}</p>
				</div>
			</md-button>
		</div>

		<!-- Language Drop-Up -->
		<div class="na-translate-submenu" v-if="languagesVisible">
			<div v-for="languageHere in activeRegion.languages" :key="languageHere" @click="setActiveLanguage(languages.find(lang => lang.shortCode == languageHere)); toggleLanguageList();" :class="{'chosen': activeLanguage ? activeLanguage.shortCode == languageHere : false}">{{ languages.find(lang => lang.shortCode == languageHere).name }}</div>
		</div>

		<!-- Language Drop-Up Button -->
		<md-button v-if="activeRegion && activeRegion.languages.length > 1" class="md-icon-button na-translate" @click="toggleLanguageList()"  :md-ripple="false" :class="{'active-Icon':languagesVisible}" @mouseover="buttonName = 'Sprachauswahl'" @mouseleave="buttonName = ''">
			<img src="@/assets/translate.svg" class="na-navbar-button-img" alt=""/>
		</md-button>

		<!-- Default Navbar -->
		<div class="na-navbar">
			<transition name="fade" mode="out-in">
				<div class="na-navbar-tooltip" :key="buttonName">{{$t(buttonName)}}</div>
			</transition>

			<div class="na-navbar-buttons">
				<md-button v-if="enableMap" class="md-icon-button" :class="{ 'active-Icon': mapVisible }" @click="toggleMap" :md-ripple="false" @mouseover="buttonName = 'Zur Übersicht'">
					<img src="@/assets/Map.svg" class="na-navbar-button-img" alt=""/>
				</md-button>														

				<md-button class="md-icon-button" :class="{ 'active-Icon': fullScreen }" @click="toggleFullScreen" :md-ripple="false" @mouseover="buttonName = 'Vollbildmodus'">
					<img src="@/assets/Fullscreen.svg" class="na-navbar-button-img" alt=""/>
				</md-button>

				<md-button v-if="enableSharing" class="md-icon-button" :class="{ 'active-Icon': sharingVisible }" @click="toggleSharing" :md-ripple="false" @mouseover="buttonName = 'Teilen'">
					<ShareIcon/>
				</md-button>

				<md-button v-if="localUserIsModerator" class="md-icon-button" @click="toggleModeratorMenue" :md-ripple="false" @mouseover="buttonName = 'Moderatorfunktionen'">
					<AccountCog/>
				</md-button>	

				<md-button v-if="!loggedIn && sessionID" class="md-icon-button" :class="{ 'active-Icon': loginDialogueVisible}"  @click="toggleLoginDialogue" :md-ripple="false" @mouseover="buttonName = 'Kommunikation'">
					<img src="@/assets/Communication.svg" class="na-navbar-button-img" alt=""/>
				</md-button>

				<md-button class="md-icon-button" :class="{ 'active-Icon': tutorialVisible}" @click="toggleTutorialDialogue" :md-ripple="false" @mouseover="buttonName = 'Hilfe'">
					<img src="@/assets/Tutorial.svg" class="na-navbar-button-img" alt=""/>
				</md-button>

				<md-button class="md-icon-button" @click="openContact()" :md-ripple="false" @mouseover="buttonName = 'Kontakt'">
					<CommentOutline/>
				</md-button>

				<md-button v-if="gyrosSupported" class="md-icon-button" :class="{ 'active-Icon': gyrosActive }" :md-ripple="false" @click="toggleGyros">
					<img src="@/assets/gyrosicon.png" class="na-navbar-button-img" alt=""/>
				</md-button>

				<md-button v-if="enableBugReport" class="md-icon-button" :class="{ 'active-Icon': bugReportVisible }" @click="toggleBugReport" :md-ripple="false" @mouseover="buttonName = 'Fehlermeldung'">
					<img src="@/assets/bugreport icon.png" class="na-navbar-button-img" alt=""/>
				</md-button>	
			</div>
		</div>	

	</div>
</template>

<script>
import {mapGetters,mapMutations} from 'vuex';

import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue'
import ShareIcon from 'vue-material-design-icons/ShareVariant.vue'
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue'
import AccountGroup from 'vue-material-design-icons/AccountGroup.vue'
import AccountCog from 'vue-material-design-icons/AccountCog.vue'
import CommentOutline from 'vue-material-design-icons/CommentOutline.vue'

export default {
	components: {ChevronDown, ChevronUp, ShareIcon, ChevronRight, AccountGroup, AccountCog, CommentOutline},
	inject: ['toggleMap','toggleGallery','toggleLoginDialogue','toggleSharing','toggleCommunication','toggleGyros','toggleBugReport','isVideoPanorama','toggleModeratorMenue',"toggleFullScreen","toggleTutorialDialogue"],
	props: ["mapVisible","fullScreen","loginDialogueVisible","gyrosActive","bugReportVisible","situationGalleryVisible","sharingVisible","loggedIn","comVisible","gyrosSupported","localUserIsModerator","tutorialVisible"],
	data: () => ({
    	buttonName: '',
		languagesVisible: false,
	}),
	computed: {
		...mapGetters(['currentSituation','enableMap',"enableSharing",'enableBugReport',"localUser",'activeLanguage',"sessionID","languages","activeRegion"]),
	},
	watch:{
	},
	methods: {
		...mapMutations(['setActiveLanguage']),
		updateShopBtnHover(){

		},
		openShop(){
			// window.dispatchEvent(new CustomEvent("openURL",{detail:{type: "Website",content: {url: this.activeLanguage.homePage}}}));
			window.open(this.activeRegion.homePage, '_blank').focus();
		},
		openContact(){
			// window.dispatchEvent(new CustomEvent("openURL",{detail:{type: "Website",content: {url:"https://www.denios.de/"}}}));
			window.open(this.activeRegion.homePage + "/#expertAdvice", '_blank').focus();
		},
		toggleLanguageList(){
			this.languagesVisible = !this.languagesVisible;
		}
	},
	mounted(){
		for(let child of document.getElementsByClassName("na-navbar-buttons")[0].children){
			child.addEventListener("mouseleave", () => {
				this.buttonName = "";
			});
		};
	}
}
</script>

<style scoped>
.Navigation{
	width: 100%;
	height: 100%;
	position: absolute;
	display: flex;
	justify-content: center;
	/* z-index:1; */
}
.na-gallery{
	position: absolute;
	height: 70px !important;
	top: 0;
	width: 100% !important;
}
.na-shop-container{
	position: absolute;
	bottom: 15px;
	right: 0px;
	overflow: hidden;
	max-width: 60px;
	transition: max-width 0.4s ease-in;
}
.na-shop-container .md-button{
	width: auto !important;
}
.na-shop-container:hover{
	max-width: 500px;
}
.na-shop{
	color: white;
	border-radius: 30px 0px 0px 30px !important;
	background: #606060 0% 0% no-repeat padding-box !important;
	box-shadow: 0px 3px 4px #0000004E !important;
}
.na-shop-wrapper{
	display: flex;
	flex-direction: row;
	align-items: center;
}
.na-shop img{
	display: inline-block;
	width: 28px;
	height: 28px;
	margin-left: 15px;
	margin-right: 10px;
}
.na-shop p{
	display: inline-block;
	text-shadow: 0px 3px 4px #0000004E;
	margin: 0 !important;
	font: normal normal 100 21px/31px Oswald;
	letter-spacing: 1.89px;
}

.na-translate{
	position: absolute;
	bottom: 16px;
	left: 16px;
	color: white;

	overflow:visible;
}

.na-translate img{
	width: 30px;
}

.na-translate-submenu{
	position: absolute; 
	left: 16px;
	bottom: 84px;
	z-index: 1;

	padding: 6px;
	border-radius: 4px;

	color: black;
	background: rgba(245,245,245);
}

.na-translate-submenu>div{
	position: relative;
	padding: 4px 12px;
	border-radius: 4px;
	cursor: pointer;
}
.na-translate-submenu>div.chosen{
	color: white;
}
.na-translate-submenu>div.chosen::before{
	content:'';
	z-index: -1;
	position: absolute;
	top:0;
	left:0;
	height: 100%;
	width: 100%;

	border-radius: 4px;
	background-color: var(--primaryColor);
}
.na-translate-submenu>div:hover{
	background-color: rgba(0,0,0,0.05);
}
.na-navbar{
	position: absolute;
	bottom: 10px !important;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}
.na-navbar-tooltip{
	z-index: 2;
	margin-bottom: 10px;
	font-size: 25px;
    color: white;
    filter: drop-shadow(0px 0px 2px rgba(0,0,0,0.4)) drop-shadow(0px 0px 10px rgba(0,0,0,0.2));
}
.na-navbar-buttons{
	justify-content: center;
    display: flex;
    flex-direction: row;
}
.na-navbar-buttons .md-button{
	margin: 5px;
}
.md-button {
	margin: 0;
	padding: 0;
}
.md-icon-button {
	border-radius: 3px;
	background-color: transparent;
	filter: drop-shadow(0px 0px 2px rgba(0,0,0,0.4)) drop-shadow(0px 0px 10px rgba(0,0,0,0.2));
	height: 50px;
	width: 60px;
}
.material-design-icon{
	height: 2.3em;
	width: 2.3em;;
}
.material-design-icon > .material-design-icon__svg{
	height: 2.3em;;
	width: 2.3em;;
	fill: white;
}
.md-icon-button .md-ripple {
	padding: 0;
	border-radius: 3px;
}
.md-icon-button:hover::before{
	background-color: #1d1d1d;
	border-radius: 2px;
}
.na-navbar-button-img{
	width: 35px; 
	height: auto;
}
.active-Icon {
	background-color: var(--primaryColor) !important;
}
.notification {
	background-color: transparent;
	animation-name: notification-animation;
	animation-duration: 0.5s;
	animation-direction: alternate;
	animation-iteration-count: infinite;
}
@keyframes notification-animation {
	from {background-color: transparent;}
	to {background-color: var(--primaryColor);}
}
.situationName{
	line-height: 30px;
	padding-top: 10px;
	cursor: pointer; 
	font-size: 2vw; 
	margin: 10px;
	color: white;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .1s;
}

/*MOBILE*/
@media (max-device-width: 900px){
	.situationName{
		font-size: 25px;
	}
}
@media (max-width: 1600px){
	.situationName{
		font-size: 25px;
	}
}
</style>